import { RootState } from "../../../redux-store";

export const selectSubcontractors = (state: RootState) =>
  state.data.subcontractors.subcontractors;
